import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/vaah-agent-orb.webm")